import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=fd80bbf0&scoped=true"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=fd80bbf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd80bbf0",
  null
  
)

export default component.exports